import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const usePropertyAccessLevelOverride = () => usePropertyContext().accessLevelOverride;